import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Stringable, StringableValues } from '../../../../common/stringable.decorator';
import { upperCase } from 'lodash';

const KEY = 'tier-adresse';
@Component({
  selector: 'atyl-tiers-adresse',
  templateUrl: './tiers-adresse.component.html',
  styleUrls: ['./tiers-adresse.component.scss']
})
@Stringable({
  path: 'views/partials/layout/tiers-adresse',
  key: KEY,
})
export class TiersAdresseComponent implements OnInit {

  @Input() tiers: any;
  @Input() relations: any;
  @Input() oneline: boolean = false;
  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  @StringableValues(KEY) strings: any;
  adresse: any;
  nbRelations: number = 0;

  constructor(
    private changeDecoratorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log("relations",this.relations)
    this.adresse = {
      id: this.tiers.adresses.PRINCIPALE.IDAdresse? this.tiers.adresses.PRINCIPALE.IDAdresse: null,
      number: this.tiers.adresses.PRINCIPALE.number !== '0' ? this.tiers.adresses.PRINCIPALE.number : '',
      complement: this.tiers.adresses.PRINCIPALE.complement ? ' ' + this.tiers.adresses.PRINCIPALE.complement : '',
      street: this.tiers.adresses.PRINCIPALE.street ? this.tiers.adresses.PRINCIPALE.street : '',
      zipCode: this.tiers.adresses.PRINCIPALE.IDzipcode ? this.tiers.adresses.PRINCIPALE.IDzipcode : '',
      distribution: this.tiers.adresses.PRINCIPALE.zipcode_label ? this.tiers.adresses.PRINCIPALE.zipcode_label : '',  
      town: this.tiers.adresses.PRINCIPALE.town ? this.tiers.adresses.PRINCIPALE.town : '',
      adresse: this.tiers.adresses.PRINCIPALE.adresse ? this.tiers.adresses.PRINCIPALE.adresse : null,
      adresse2: this.tiers.adresses.PRINCIPALE.adresse2 ? this.tiers.adresses.PRINCIPALE.adresse2 : null,
    };
  }
  ngOnChanges(changes: any) {
    if (changes.tiers) {
      this.__generateAdresse__();
    }
  }

  private __generateAdresse__() {
    this.adresse = {
      id: this.tiers.adresses.PRINCIPALE.IDAdresse? this.tiers.adresses.PRINCIPALE.IDAdresse: null,
      number: this.tiers.adresses.PRINCIPALE.number !== '0' ? this.tiers.adresses.PRINCIPALE.number : '',
      complement: this.tiers.adresses.PRINCIPALE.complement ? ' ' + this.tiers.adresses.PRINCIPALE.complement : '',
      street: this.tiers.adresses.PRINCIPALE.street ? this.tiers.adresses.PRINCIPALE.street : '',
      zipCode: this.tiers.adresses.PRINCIPALE.IDzipcode ? this.tiers.adresses.PRINCIPALE.IDzipcode : '',
      distribution: this.tiers.adresses.PRINCIPALE.zipcode_label ? this.tiers.adresses.PRINCIPALE.zipcode_label : '',
      town: this.tiers.adresses.PRINCIPALE.town ? this.tiers.adresses.PRINCIPALE.town : '',
      adresse: this.tiers.adresses.PRINCIPALE.adresse ? this.tiers.adresses.PRINCIPALE.adresse : null,
      adresse2: this.tiers.adresses.PRINCIPALE.adresse2 ? this.tiers.adresses.PRINCIPALE.adresse2 : null,
    };
    this.changeDecoratorRef.detectChanges();
  }
  
  getAdresseHTML() {
	  let add:string[]=[];
	  let rues:string[]=[];
	
	  if (this.adresse.number.length>0)
	       rues.push(this.adresse.number);
	  if (this.adresse.complement.length>0)
	       rues.push(this.adresse.complement);
	   if (this.adresse.street.length>0)
	       rues.push(this.adresse.street);   
	   if (rues.length>0)
	      add.push(rues.join(" "));
	  
	  let ville:string[]=[];
	  if (this.adresse.zipCode.length>0)
	       ville.push(this.adresse.zipCode);
	   if (this.adresse.town.length>0)
	       ville.push(this.adresse.town);        
	   if (this.adresse.zipCode.length>0 
	   && this.adresse.distribution.length>0 
	   && this.adresse.town.length>0 
	   && this.adresse.zipCode!=this.adresse.distribution
	   && this.adresse.town!=this.adresse.distribution
	   )
	      ville.push("(" + this.adresse.distribution + ")");  
	   if (this.adresse.adresse)
	  		add.push(upperCase(this.adresse.adresse));
	   if (this.adresse.adresse2)
	  		add.push(upperCase(this.adresse.adresse2));
	  			
	  if (ville.length>0)
	      add.push(ville.join(" "));	
		  
	 
	  return add.join("<br/>");
	  
  }

}
